<template>
  <!-- 素材下载 文稿统计 -->
  <div class="statistics-container">
    <div class="header">
      <img
        src="../../../assets/Uram/sourceMaterial/articleLogo_02.png"
        alt=""
      />
      <div class="bodyTitle">{{ title }}</div>
    </div>
    <div class="body-main">
      <div class="body-left">
        <div class="left-container">
          <div class="left-title">{{ left_title }}</div>
          <div id="echars1"></div>
          <div class="echarts-label">
            <span>{{ echarts1_label }}</span>
          </div>
        </div>
      </div>
      <div class="body-right">
        <div class="right-container">
          <div class="left-title">{{ right_title }}</div>
          <div id="echars2"></div>
          <div class="echarts-label">
            <span>{{ echarts2_label }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from "echarts";
import { getFodderList } from "../../../api/UramWu/uram";
import { getAmountList } from "../../../api/UramWu/uram";
export default {
  data() {
    return {
      title: "素材下载 文稿统计",
      left_title: "素材下载量TOP10",
      echarts1_label: "用户内容库素材下载量统计数据",
      right_title: "文稿使用数量",
      echarts2_label: "记者稿件新媒体引用情况统计",
      // echarts2_label: "记者再文稿里写的稿件，在新媒体渠道被使用的次数"
    };
  },
  created() {
    this.load();
  },
  mounted() {
    // var a = echarts.init(document.getElementById("echars1"));
    // this.$http.get(`${this.BASE_URL.url}getFodderList.jspx`).then(res => {
    //   var series_data = res.data.data.map(k => {
    //     return {
    //       name: k.targetName,
    //       value: k.total
    //     };
    //   });
    //   var aOption = {
    //     tooltip: {
    //       trigger: "item",
    //       formatter: "{a} <br/>{b} : {c} ({d}%)"
    //     },
    //     calculable: true,
    //     color: [
    //       "#E137E2",
    //       "#C7191A",
    //       "#FF5D15",
    //       "#FF9600",
    //       "#E6E300",
    //       "#3AB878",
    //       "#01D3F8",
    //       "#2F85FF"
    //     ],
    //     series: [
    //       {
    //         name: "统计数据",
    //         type: "pie",
    //         radius: ["15%", "60%"],
    //         center: ["50%", "50%"],
    //         roseType: "area",
    //         data: series_data,
    //         label: {
    //           formatter: get,
    //           // borderColor:'white',
    //           borderWidth: 1,
    //           borderRadius: 4,
    //           lineHeight: 18,
    //           rich: {
    //             b: {
    //               lineHeight: 20
    //             }
    //           }
    //           // rich: {
    //           // 	a: {
    //           // 		color: '#999',
    //           // 		lineHeight: 22,
    //           // 		align: 'center'
    //           // 	},
    //           // 	// abg: {
    //           // 	//     backgroundColor: '#333',
    //           // 	//     width: '100%',
    //           // 	//     align: 'right',
    //           // 	//     height: 22,
    //           // 	//     borderRadius: [4, 4, 0, 0]
    //           // 	// },
    //           // 	hr: {
    //           // 		borderColor: '#aaa',
    //           // 		width: '100%',
    //           // 		borderWidth: 0.5,
    //           // 		height: 0
    //           // 	},
    //           // 	b: {
    //           // 		fontSize: 16,
    //           // 		lineHeight: 33
    //           // 	},
    //           // 	per: {
    //           // 		color: '#eee',
    //           // 		backgroundColor: '#334455',
    //           // 		padding: [2, 4],
    //           // 		borderRadius: 2
    //           // 	}
    //           // }
    //         }
    //       }
    //     ]
    //   };
    //   a.setOption(aOption);
    //   window.addEventListener("resize", () => {
    //     a.resize();
    //   });
    // });
    // var get = function(e) {
    //   var newStr = " ";
    //   var start, end;
    //   var name_len = e.name.length; //每个内容名称的长度
    //   var max_name = 8; //每行最多显示的字数
    //   var new_row = Math.ceil(name_len / max_name); // 最多能显示几行，向上取整比如2.1就是3行
    //   if (name_len > max_name) {
    //     //如果长度大于每行最多显示的字数
    //     for (var i = 0; i < new_row; i++) {
    //       //循环次数就是行数
    //       var old = ""; //每次截取的字符
    //       start = i * max_name; //截取的起点
    //       end = start + max_name; //截取的终点
    //       if (i == new_row - 1) {
    //         //最后一行就不换行了
    //         old = e.name.substring(start);
    //       } else {
    //         old = e.name.substring(start, end) + "\n";
    //       }
    //       newStr += old; //拼接字符串
    //     }
    //   } else {
    //     //如果小于每行最多显示的字数就返回原来的字符串
    //     newStr = e.name;
    //   }
    //   return newStr;
    // };
    // var b = echarts.init(document.getElementById("echars2"));
    // this.$http.get(`${this.BASE_URL.url}getAmountList.jspx`).then(res => {
    //   var y_data = res.data.data.map(k => {
    //     return k.username;
    //   });
    //   var series_data_sina = res.data.data.map(k => {
    //     return k.sina;
    //   });
    //   var series_data_website = res.data.data.map(k => {
    //     return k.website;
    //   });
    //   var series_data_wechat = res.data.data.map(k => {
    //     return k.wechat;
    //   });
    //   var bOption = {
    //     tooltip: {
    //       trigger: "axis",
    //       axisPointer: {
    //         // 坐标轴指示器，坐标轴触发有效
    //         type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
    //       }
    //     },
    //     grid: {
    //       left: "3%",
    //       right: "4%",
    //       bottom: "3%",
    //       top: "5%",
    //       containLabel: true
    //     },
    //     color: ["#3aa1fe", "#4fcb73", "#ffdf5c"],
    //     xAxis: {
    //       type: "value",
    //       splitLine: {
    //         lineStyle: {
    //           color: "#1d2d46",
    //           type: "dashed"
    //         }
    //       },
    //       axisLine: {
    //         lineStyle: {
    //           color: "#fff"
    //         }
    //       }
    //     },
    //     yAxis: {
    //       type: "category",
    //       data: y_data,
    //       axisLine: {
    //         lineStyle: {
    //           color: "#fff"
    //         }
    //       }
    //     },
    //     series: [
    //       {
    //         name: "图文",
    //         type: "bar",
    //         stack: "总量",
    //         barMaxWidth: "30",
    //         label: {
    //           normal: {
    //             show: true,
    //             position: "insideRight"
    //           }
    //         },
    //         data: series_data_website
    //       },
    //       {
    //         name: "微信",
    //         type: "bar",
    //         stack: "总量",
    //         label: {
    //           normal: {
    //             show: true,
    //             position: "insideRight"
    //           }
    //         },
    //         data: series_data_wechat
    //       },
    //       {
    //         name: "微博",
    //         type: "bar",
    //         stack: "总量",
    //         label: {
    //           normal: {
    //             show: true,
    //             position: "insideRight"
    //           }
    //         },
    //         data: series_data_sina
    //       }
    //     ]
    //   };
    //   b.setOption(bOption);
    //   window.addEventListener("resize", () => {
    //     b.resize();
    //   });
    // });
  },
  methods: {
    load() {
      getFodderList().then((res) => {
        var series_data = res.data.data.map((k) => {
          return {
            name: k.targetName,
            value: k.total,
          };
        });
        var aOption = {
          tooltip: {
            trigger: "item",
            formatter: "{a} <br/>{b} : {c} ({d}%)",
          },
          calculable: true,
          color: [
            "#E137E2",
            "#C7191A",
            "#FF5D15",
            "#FF9600",
            "#E6E300",
            "#3AB878",
            "#01D3F8",
            "#2F85FF",
          ],
          series: [
            {
              name: "统计数据",
              type: "pie",
              radius: ["15%", "60%"],
              center: ["50%", "50%"],
              roseType: "area",
              data: series_data,
              label: {
                formatter: get,
                // borderColor:'white',
                borderWidth: 1,
                borderRadius: 4,
                lineHeight: 18,
                rich: {
                  b: {
                    lineHeight: 20,
                  },
                },
                // rich: {
                // 	a: {
                // 		color: '#999',
                // 		lineHeight: 22,
                // 		align: 'center'
                // 	},
                // 	// abg: {
                // 	//     backgroundColor: '#333',
                // 	//     width: '100%',
                // 	//     align: 'right',
                // 	//     height: 22,
                // 	//     borderRadius: [4, 4, 0, 0]
                // 	// },
                // 	hr: {
                // 		borderColor: '#aaa',
                // 		width: '100%',
                // 		borderWidth: 0.5,
                // 		height: 0
                // 	},
                // 	b: {
                // 		fontSize: 16,
                // 		lineHeight: 33
                // 	},
                // 	per: {
                // 		color: '#eee',
                // 		backgroundColor: '#334455',
                // 		padding: [2, 4],
                // 		borderRadius: 2
                // 	}
                // }
              },
            },
          ],
        };
        var a = echarts.init(document.getElementById("echars1"));
        a.setOption(aOption);
        window.addEventListener("resize", () => {
          a.resize();
        });
      });
      var get = function(e) {
        var newStr = " ";
        var start, end;
        var name_len = e.name.length; //每个内容名称的长度
        var max_name = 8; //每行最多显示的字数
        var new_row = Math.ceil(name_len / max_name); // 最多能显示几行，向上取整比如2.1就是3行
        if (name_len > max_name) {
          //如果长度大于每行最多显示的字数
          for (var i = 0; i < new_row; i++) {
            //循环次数就是行数
            var old = ""; //每次截取的字符
            start = i * max_name; //截取的起点
            end = start + max_name; //截取的终点
            if (i == new_row - 1) {
              //最后一行就不换行了
              old = e.name.substring(start);
            } else {
              old = e.name.substring(start, end) + "\n";
            }
            newStr += old; //拼接字符串
          }
        } else {
          //如果小于每行最多显示的字数就返回原来的字符串
          newStr = e.name;
        }
        return newStr;
      };

      getAmountList().then((res) => {
        var y_data = res.data.data.map((k) => {
          return k.username;
        });
        var series_data_sina = res.data.data.map((k) => {
          return k.sina;
        });
        var series_data_website = res.data.data.map((k) => {
          return k.website;
        });
        var series_data_wechat = res.data.data.map((k) => {
          return k.wechat;
        });
        var bOption = {
          tooltip: {
            trigger: "axis",
            axisPointer: {
              // 坐标轴指示器，坐标轴触发有效
              type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
            },
          },
          grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            top: "5%",
            containLabel: true,
          },
          color: ["#3aa1fe", "#4fcb73", "#ffdf5c"],
          xAxis: {
            type: "value",
            splitLine: {
              lineStyle: {
                color: "#1d2d46",
                type: "dashed",
              },
            },
            axisLine: {
              lineStyle: {
                color: "#fff",
              },
            },
          },
          yAxis: {
            type: "category",
            data: y_data,
            axisLine: {
              lineStyle: {
                color: "#fff",
              },
            },
          },
          series: [
            {
              name: "图文",
              type: "bar",
              stack: "总量",
              barMaxWidth: "30",
              label: {
                normal: {
                  show: true,
                  position: "insideRight",
                },
              },
              data: series_data_website,
            },
            {
              name: "微信",
              type: "bar",
              stack: "总量",
              label: {
                normal: {
                  show: true,
                  position: "insideRight",
                },
              },
              data: series_data_wechat,
            },
            {
              name: "微博",
              type: "bar",
              stack: "总量",
              label: {
                normal: {
                  show: true,
                  position: "insideRight",
                },
              },
              data: series_data_sina,
            },
          ],
        };
        var b = echarts.init(document.getElementById("echars2"));
        b.setOption(bOption);
        window.addEventListener("resize", () => {
          b.resize();
        });
      });
    },
  },
};
</script>

<style lang="scss">
.statistics-container {
  background-image: url("../../../assets/Uram/sourceMaterial/wnmq.png");
  background-size: 100% 100%;
  position: relative;
  height: 100%;
  .header {
    padding: 4.9vh 3.65% 2vh 4.2%;
    img {
      position: absolute;
      top: 3.5vh;
      left: 4.3%;
      width: 2.5%;
    }
    .bodyTitle {
      color: #fff;
      font-size: 1.94vw;
      font-weight: bold;
      display: inline-block;
      width: 20.8%;
      text-align: center;
      margin-left: 1.5%;
    }
  }
  .body-main {
    height: calc(100% - 2.9vh - 39px - 2vh - 6vh);
    padding: 2vh 4.1% 6vh 4%;
    display: flex;
    width: 100%;
    .left-title {
      margin: 3vh 0 0 1.5vw;
      color: #fff;
    }
    .echarts-label {
      width: 100%;
      text-align: center;
      color: #90909a;
      font-size: 0.84vw;
    }
    .body-left {
      width: 50%;
      height: 100%;
      background-image: url("../../../assets/Uram/sourceMaterial/35.png");
      background-size: 100% 100%;
      .left-container {
        margin: 20px;
        height: calc(100% - 40px);
        background-color: rgba(0, 37, 93, 0.1);
        #echars1 {
          width: 100%;
          height: calc(100% - 0.84vw - 2vh - 3vh);
        }
      }
    }
    .body-right {
      width: 50%;
      height: 100%;
      margin-left: 1%;
      background-image: url("../../../assets/Uram/sourceMaterial/25.png");
      background-size: 100% 100%;
      .right-container {
        margin: 20px;
        height: calc(100% - 40px);
        #echars2 {
          width: 100%;
          height: calc(100% - 0.84vw - 2vh - 3vh);
        }
      }
    }
  }
}
</style>
